import React from 'react';
import HeroArea from "./HeroArea";
import Features from "./Features";
import Services from "./Services";
import Products from "./Products";
import Testimonials from "./Testimonials";
import News from './News';

class HomeNew extends React.Component  {
    render() {
        return(
            <div>
                <HeroArea />
                <Features />
                <News />
                <Services />
                <Products />
                <Testimonials />
            </div>
        );
    }
}



export default HomeNew;



// WEBPACK FOOTER //
// ./src/components/HomeNew.js